import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';
import { createTheme } from '@material-ui/core/styles';

import appTheme from 'styles/themes/app';

type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};

type MuiPickersBasePickerType = {
  MuiPickersBasePicker: {
    container: unknown;
    pickerView: unknown;
  };
};

declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey extends overridesNameToClassKey {}
  export interface ComponentNameToClassKey extends MuiPickersBasePickerType {}
}

export const theme = createTheme({
  ...appTheme,
  overrides: {
    MuiPickersBasePicker: {
      container: {
        padding: 20,
      },
      pickerView: {
        justifyContent: 'unset',
        minWidth: 'unset',
        minHeight: 284,
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: 'unset',
      },
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        width: 32,
      },
      switchHeader: {
        padding: '16px 0',
      },
      transitionContainer: {
        color: appTheme.palette.primary.main,
        '& > p': {
          fontWeight: 600,
          fontSize: 14,
        },
      },
      iconButton: {
        color: appTheme.palette.primary.main,
      },
    },
    MuiPickersDay: {
      day: {
        width: 32,
        height: 32,
        '& p': {
          color: '#3D3D3D',
          fontSize: 15,
          lineHeight: '18px',
          fontWeight: 600,
        },
      },
      daySelected: {
        backgroundColor: appTheme.palette.primary.main,
        '&:hover': {
          backgroundColor: appTheme.palette.primary.main,
        },
        '& p': {
          color: appTheme.palette.common.white,
        },
      },
      dayDisabled: {
        '& p': {
          color: appTheme.palette.grey['200'],
        },
      },
    },
    MuiPopover: {
      paper: {
        borderRadius: 10,
        boxShadow: '0px 3px 5px #00000026',
      },
    },
  },
});
